import { render } from "./LoadingProductsSkeleton.vue?vue&type=template&id=74404afb&scoped=true"
import script from "./LoadingProductsSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadingProductsSkeleton.vue?vue&type=script&lang=js"

import "./LoadingProductsSkeleton.vue?vue&type=style&index=0&id=74404afb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74404afb"]])

export default __exports__